/*
 * @Author: shen
 * @Date: 2021-07-18 10:47:09
 * @LastEditors: shen
 * @LastEditTime: 2021-07-25 22:37:09
 * @Description:
 */
export function isObject(val) {
  return val !== null && typeof val === 'object';
}

export function isArray(val) {
  return Array.isArray(val);
}

export function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }
  const prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

export function isUndefined(val) {
  return typeof val === 'undefined';
}

export function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  if (typeof obj !== 'object') {
    obj = [obj];
  }

  if (Array.isArray(obj)) {
    for (let i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

export function merge(...argvs) {
  const result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (Array.isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (let i = 0, l = argvs.length; i < l; i++) {
    forEach(argvs[i], assignValue);
  }
  return result;
}

export function deepClone(obj) {
  const objClone = isArray(obj) ? [] : {};
  if (isObject(obj) || isArray(obj)) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (isObject(obj[key]) || isArray(obj[key])) {
          objClone[key] = deepClone(obj[key]);
        } else {
          objClone[key] = obj[key];
        }
      }
    }
  }
}

export function isPromise(val) {
  return val && typeof val.then === 'function';
}

export function assert(condition, msg) {
  if (!condition) throw new Error(`[wx-store] ${msg}`);
}
